/*!
 * Copyright © 2019-2023. Verizon Connect Ireland Limited. All rights reserved.
 */

import { ScrollingModule } from '@angular/cdk/scrolling';
import { CdkTreeModule } from '@angular/cdk/tree';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatLegacyCheckboxModule } from '@angular/material/legacy-checkbox';
import { VirtualScrollViewportResizeModule } from '../shared';
import { ScopingTreeComponent } from './scoping-tree.component';

@NgModule({
  imports: [CdkTreeModule, CommonModule, ScrollingModule, VirtualScrollViewportResizeModule, MatLegacyCheckboxModule],
  declarations: [ScopingTreeComponent],
  exports: [ScopingTreeComponent]
})
export class ScopingTreeModule {}
